
import http from "../http-common";

class PartService {
  getAll() {
    return http.get("/parts");
  }

  getUnitParts(unitID) {
    return http.get(`/parts?unitid=${unitID}`);
  }

  get(partID) {
    return http.get(`/parts/${partID}`);
  }

  create(data) {
    return http.post("/parts", data);
  }

  update(partID, data) {
    return http.put(`/parts/${partID}`, data);
  }

  delete(partID) {
    return http.delete(`/parts/${partID}`);
  }

  deleteAll() {
    return http.delete(`/parts`);
  }

  findByName(partName) {
    return http.get(`/parts?partname=${partName}`);
  }

  findByMake(partMake) {
    return http.get(`/parts?partmake=${partMake}`);
  }

  findByModel(partModel) {
    return http.get(`/parts?partmodel=${partModel}`);
  }

  findBySN(partSN) {
    return http.get(`/parts?partsn=${partSN}`);
  }
}

export default new PartService();